import { useFlag } from 'lane-shared/hooks';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsMultiPhotoCaptureEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsMultiPhotoCapture,
    false
  );

  return Boolean(isEnabled);
}
